export default defineNuxtRouteMiddleware((to, from) => {
    // Routes that should NOT redirect to login
    const publicAuthRoutes = [
        '/login',
        '/theme-mfa'
    ];


    // If we're on one of the allowed routes → do nothing
    if (publicAuthRoutes.some(path => to.path.startsWith(path))) {
        return; // allow navigation
    }

    const { project = '', openTaskModal = '', redirect: redirectToParam } = to.query || {};
    const nuxtApp = useNuxtApp();
    const store = nuxtApp.$vuex;

    if (store.state.auth.loggedIn) {
        const isParticipant = store.state.auth.user?.isParticipant;
        const params = [];
        if (project.trim()) params.push(`project=${encodeURIComponent(project)}`);
        if (openTaskModal.trim()) params.push(`openTaskModal=${encodeURIComponent(openTaskModal)}`);
        const queryString = params.length ? `?${params.join('&')}` : '';

        const themeCookie = useCookie('participantProjectSlugTheme');
        const slug = themeCookie.value || 'app';

        let redirectUrl;
        if (isParticipant) {
            if (redirectToParam && redirectToParam !== '/') {
                redirectUrl = `${redirectToParam}${queryString}`;
            } else {
                redirectUrl = `/${slug}/participant${queryString}`;
            }
        } else {
            const usersTheme = store.state.auth?.user?.theme?.slug || to.params.theme || 'app';
            redirectUrl = `/${usersTheme}/admin/accounts`;
        }

        themeCookie.value = null;
        return navigateTo(redirectUrl);
    }

    return navigateTo('/login');
});
